import React from 'react';
import { Button, type ButtonProps } from './Button';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  actionButtonProps?: ButtonProps;
  className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  actionLabel,
  onAction,
  actionButtonProps,
  className = '',
}: EmptyStateProps) {
  return (
    <div className={`flex flex-col items-center justify-center p-8 sm:p-12 text-center rounded-2xl border border-dashed border-line bg-card/50 ${className}`}>
      {icon && (
        <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-blue-500/10 text-blue-500 text-3xl shadow-sm">
          {icon}
        </div>
      )}
      <h3 className="text-lg font-bold text-ink tracking-tight">{title}</h3>
      {description && (
        <p className="mt-2 text-sm text-sub max-w-md leading-relaxed">{description}</p>
      )}
      {action ? (
        <div className="mt-6">{action}</div>
      ) : actionLabel && onAction ? (
        <div className="mt-6">
          <Button variant="btn-p" size="md" onClick={onAction} {...actionButtonProps}>
            {actionLabel}
          </Button>
        </div>
      ) : null}
    </div>
  );
}
